import React, { useState, useRef } from 'react';
import './EditableInputBox.css';
import CheckIcon from '../UIElements/CheckIcon/CheckIcon';
import CancelIcon from '../UIElements/CancelIcon/CancelIcon';
import EditIconBtn from '../UIElements/EditIconBtn';

const EditableInputBox = ({ defaultValue = 0, onSubmit, maxValue }) => {
  const [value, setValue] = useState(`Score ${defaultValue}`);
  const [isEditing, setIsEditing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const inputRef = useRef(null);
  const originalValue = `Score ${defaultValue}`;

  const handleInputChange = e => {
    const newValue = e.target.value;

    if (!/^\d*$/.test(newValue)) {
      return;
    }

    setValue(newValue);

    if (Number(newValue) <= maxValue) {
      setErrorMessage('');
    } else {
      setErrorMessage(`Value must not exceed ${maxValue}.`);
    }
  };

  const handleEditClick = () => {
    setValue(value.replace('Score ', ''));
    setIsEditing(true);

    setTimeout(() => {
      inputRef.current.focus();
    }, 0);
  };

  const handleConfirmClick = () => {
    if (value.trim) {
      setValue(`Score ${value.trim()}`);
      onSubmit(value.trim());
      setIsEditing(false);
    }
  };

  const handleCancelClick = () => {
    setValue(originalValue);
    setIsEditing(false);
    setErrorMessage('');
  };

  return (
    <>
      <div className="editable-container">
        <div className="input-wrapper">
          <input
            type="text"
            value={value}
            ref={inputRef}
            readOnly={!isEditing}
            onChange={handleInputChange}
            className={isEditing ? 'editable-input' : 'editable-input-disabled'}
          />
          {!isEditing && (
            <span className="edit-icon" onClick={handleEditClick}>
              <EditIconBtn />
            </span>
          )}
        </div>
        {isEditing && (
          <>
            <button
              className="confirm-icon"
              onClick={handleConfirmClick}
              disabled={!!errorMessage}
            >
              <CheckIcon />
            </button>
            <button className="cancel-icon" onClick={handleCancelClick}>
              <CancelIcon />
            </button>
          </>
        )}
      </div>
      {errorMessage && (
        <div className="editableinput_errorMessage">{errorMessage}</div>
      )}
    </>
  );
};

export default EditableInputBox;
